import { Flipper } from 'domains/insights-portal/access-control/flippers'
import { InsightsPortalSchema } from 'domains/insights-portal/api'
import { useDomainAccessControl } from 'domains/insights-portal/utils/domain/accessControl'

// Add mapping from a Snowflake schema to its corresponding Clickhouse schema here
const SNOWFLAKE_TO_CLICKHOUSE_SCHEMA: {
  [key in InsightsPortalSchema]?: InsightsPortalSchema
} = {
  [InsightsPortalSchema.OrderDelivery]: InsightsPortalSchema.OrderDeliveryClickhouse,
  [InsightsPortalSchema.OrderDeliveryHistoricalGrowth]:
    InsightsPortalSchema.OrderDeliveryHistoricalGrowthClickhouse,

  [InsightsPortalSchema.OrderItem]: InsightsPortalSchema.OrderItemClickhouse,
  [InsightsPortalSchema.OrderItemHistoricalGrowth]:
    InsightsPortalSchema.OrderItemHistoricalGrowthClickhouse,
  [InsightsPortalSchema.ProductByCategoryBenchmark]:
    InsightsPortalSchema.ProductByCategoryBenchmarkClickhouse,
  [InsightsPortalSchema.ProductByPartnerBenchmark]:
    InsightsPortalSchema.ProductByPartnerBenchmarkClickhouse,
  [InsightsPortalSchema.OrderItemStitchProductByCategoryBenchmark]:
    InsightsPortalSchema.OrderItemStitchProductByCategoryBenchmarkClickhouse,
  [InsightsPortalSchema.OrderItemStitchProductByCategoryBenchmarkHistoricalGrowth]:
    InsightsPortalSchema.OrderItemStitchProductByCategoryBenchmarkHistoricalGrowthClickhouse,

  [InsightsPortalSchema.SearchTerm]: InsightsPortalSchema.SearchTermClickhouse,
  [InsightsPortalSchema.SearchTermHistoricalGrowth]:
    InsightsPortalSchema.SearchTermHistoricalGrowthClickhouse,
  [InsightsPortalSchema.SearchTermByPartnerBenchmark]:
    InsightsPortalSchema.SearchTermByPartnerBenchmarkClickhouse,
  [InsightsPortalSchema.SearchTermByTermBenchmark]:
    InsightsPortalSchema.SearchTermByTermBenchmarkClickhouse,
  [InsightsPortalSchema.SearchTermStitchSearchTermByTermBenchmark]:
    InsightsPortalSchema.SearchTermStitchSearchTermByTermBenchmarkClickhouse,
  [InsightsPortalSchema.SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowth]:
    InsightsPortalSchema.SearchTermStitchSearchTermByTermBenchmarkHistoricalGrowthClickhouse,

  [InsightsPortalSchema.ImageCoverage]: InsightsPortalSchema.ImageCoverageClickhouse,
  [InsightsPortalSchema.ImageCoverageHistoricalGrowth]:
    InsightsPortalSchema.ImageCoverageHistoricalGrowthClickhouse,
  [InsightsPortalSchema.MissingImage_90DayRetailerInsights]:
    InsightsPortalSchema.MissingImage_90DayRetailerInsightsClickhouse,
}

// Add dashboard-specific Clickhouse flippers here
const DASHBOARD_TO_CLICKHOUSE_FLIPPER: Record<string, Flipper> = {
  'insights-portal/performance/overview': Flipper.ClickhousePerformance,
  'insights-portal/performance/out-of-stock': Flipper.ClickhouseOutOfStock,
  'insights-portal/performance/basket': Flipper.ClickhouseBasket,
  'insights-portal/performance/search': Flipper.ClickhouseSearch,
  'insights-portal/custom-report': Flipper.ClickhouseDataExplorer,
  'insights-portal/executive-summary': Flipper.ClickhouseExecutiveSummary,
}

const useClickhouseSchemaSubstitution = (schema: InsightsPortalSchema): InsightsPortalSchema => {
  const hasAccess = useDomainAccessControl()

  if (schema in SNOWFLAKE_TO_CLICKHOUSE_SCHEMA) {
    // if the current page url contains one of the dashboard paths above, we'll check the corresponding flipper
    const flipper =
      DASHBOARD_TO_CLICKHOUSE_FLIPPER[
        Object.keys(DASHBOARD_TO_CLICKHOUSE_FLIPPER).find(d => window.location.pathname.includes(d))
      ]

    if (
      flipper &&
      hasAccess([
        {
          flippers: flipper,
        },
        {
          warehouseFlippers: flipper,
        },
      ])
    ) {
      return SNOWFLAKE_TO_CLICKHOUSE_SCHEMA[schema]
    }

    return schema
  }

  return schema
}

export const useSchema = (schema: InsightsPortalSchema): InsightsPortalSchema =>
  useClickhouseSchemaSubstitution(schema)
